import { useEffect, useState } from "react";

import { Box, Dialog } from "@mui/material";

import {
  mpGatedModuleModalViewed,
  mpSmartPricingGateViewed,
} from "@src/utils/mixpanel";
import { useIsInView } from "@src/hooks/is-in-view";
import { PricingGatedModalContent } from "./PricingGatedModalContent";
import { BillingModuleGateDemo } from "./BillingModuleGateDemo";
import type { PricingGatedModalViewProps } from "./PricingGatedModal.view.types";
import {
  SMART_PRICING_LIMITED_ID,
  SMART_PRICING_UNLIMITED_ID,
} from "@src/constants/billing";

export const PricingGatedModalView = ({
  buttons,
  gateModuleDetails,
  moduleId,
  open,
  onClose,
  orderVolumeTier,
  showInlineViewDemo,
  userState,
  videoPlaybackId,
}: PricingGatedModalViewProps) => {
  const { name } = gateModuleDetails;
  const { ref: viewRef, isInView } = useIsInView();
  const [isDemoOpen, setIsDemoOpen] = useState(false);

  useEffect(() => {
    if (!isInView) {
      return;
    }

    if (
      moduleId === SMART_PRICING_LIMITED_ID ||
      moduleId === SMART_PRICING_UNLIMITED_ID
    ) {
      mpSmartPricingGateViewed({
        ctasShown: buttons.map((button) => button.label),
        orderVolumeTier,
        userState,
      });
    } else {
      mpGatedModuleModalViewed({
        moduleName: name,
        userState,
      });
    }
  }, [isInView, name, orderVolumeTier, userState]);

  return (
    <Dialog
      onClose={onClose}
      open={open}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "800px",
          },
        },
      }}
    >
      <Box sx={{ position: "relative" }} ref={viewRef}>
        {videoPlaybackId && isDemoOpen ? (
          <BillingModuleGateDemo
            buttons={buttons}
            gateModuleDetails={gateModuleDetails}
            moduleId={moduleId}
            onBack={() => setIsDemoOpen(false)}
            orderVolumeTier={orderVolumeTier}
            userState={userState}
            videoPlaybackId={videoPlaybackId}
          />
        ) : (
          <PricingGatedModalContent
            buttons={buttons}
            gateModuleDetails={gateModuleDetails}
            moduleId={moduleId}
            onClose={onClose}
            onViewDemo={videoPlaybackId ? () => setIsDemoOpen(true) : undefined}
            showInlineViewDemo={showInlineViewDemo}
          />
        )}
      </Box>
    </Dialog>
  );
};
